import { TotalDataType } from '@components/_organism/service/TotalCard';
import { parseCalcTotalData } from '@hooks/service/parseCalcTotalData';
import { parseItemDescription } from '@hooks/service/parseItemDescription';
import { QuotationSaleSelfGetSaleQuotationItemSelfDataType } from 'models/SupplementType';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

/**
 *  총계 계산
 *  판매자 견적서 작성에서 쓰는 hook을 재사용하기위해 "임시"로 해당 form 형식으로 가공
 */
export const useGetTotalCardData = (
  itemData: QuotationSaleSelfGetSaleQuotationItemSelfDataType[],
  itemIds: number[],
): TotalDataType[] => {
  const { i18n } = useTranslation();
  const ko = i18n.language === 'ko';

  const result = useMemo(() => {
    const data = itemData
      .filter((row) => itemIds.includes(row.id!))
      .map((row) => {
        const { id, quantity, unit_price, item } = row;

        return {
          item_id: id!,
          quantity: quantity!,
          unit_price: unit_price!,
          total_price: quantity! * unit_price!,
          itemDescription: item ? parseItemDescription(item) : '',
          product_type: item?.product?.product_type || 'ETC',
        };
      });

    return parseCalcTotalData(data, ko);
  }, [itemIds, itemData, ko]);

  return result;
};
